import { IconFormIndicatorError } from '@components/icons/form-indicator-error';
import { IconFormIndicatorInfo } from '@components/icons/form-indicator-info';
import { IconFormIndicatorPending } from '@components/icons/form-indicator-pending';
import { IconFormIndicatorSuccess } from '@components/icons/form-indicator-success';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { useStore } from 'models/Provider';

import { FileUploadStatus } from './api';

export function FileStatus({ status }: { status: FileUploadStatus }) {
  const { t } = useStore();

  switch (status) {
    case 'S':
      return (
        <Stack space={2} orientation="horizontal" align="center">
          <IconFormIndicatorSuccess />
          <Text font="regular16" color="green200" text={t('integrations.onecrm.transfer.s')} />
        </Stack>
      );
    case 'E':
      return (
        <Stack space={2} orientation="horizontal" align="center">
          <IconFormIndicatorError />
          <Text font="regular16" color="red200" text={t('integrations.onecrm.transfer.e')} />
        </Stack>
      );
    case 'P':
      return (
        <Stack space={2} orientation="horizontal" align="center">
          <IconFormIndicatorPending />
          <Text font="regular16" color="orange200" text={t('integrations.onecrm.transfer.p')} />
        </Stack>
      );
    case 'N':
      return (
        <Stack space={2} orientation="horizontal" align="center">
          <IconFormIndicatorInfo color="purple50" />
          <Text font="regular16" color="purple200" text={t('integrations.onecrm.transfer.n')} />
        </Stack>
      );
    default:
      return null;
  }
}
